<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">
    
    <CreateEditEventoInscricaoDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <EnviarLinkPagamentoDialog :item="item" v-model="enviarLinkPagamentoDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <EfetivarIncricaoDialog 
      v-model="efetivarIncricaoDialogOpened"
      :edicaoEvento="inscricaoEvento"
      :autenticacao="autenticacao"
      :autenticado="autenticado"
      />

    <div>
      <EventoInscricaoDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                             @click:detalheInscricao="detalheInscricao"
                             @click:enviarLinkPagamento="enviarLinkPagamento"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import EventoInscricaoDataTable from "../../components/shared/datatables/EventoInscricaoDataTable";
import EfetivarIncricaoDialog from "@/views/EventoInscricao/components/EfetivarIncricaoDialog";
import BaseView from "../BaseView";
import {findOne, findInscricaoPorToken, remove} from "../../api/eventoInscricao";
import CreateEditEventoInscricaoDialog from "../../components/shared/dialogs/CreateEditEventoInscricaoDialog";
import EnviarLinkPagamentoDialog from "../../components/shared/dialogs/EnviarLinkPagamentoDialog";
import {findAll as findAllEvento} from '../../api/evento';
import {findAll as findAllEventoTipo} from '../../api/eventoTipo';
import {ItemDeDominio} from "../../api/itemsDominio";
import {mapActions, mapGetters} from "vuex";
import {ApiError} from "@/api/core";

export default {
  name: "index",
  components: {CreateEditEventoInscricaoDialog, BaseView, EventoInscricaoDataTable, EfetivarIncricaoDialog, EnviarLinkPagamentoDialog},
  data() {
    return {
      item: null,
      inscricaoEvento: {},
      autenticacao: {},
      autenticado: false,
      loading: false,
      editDialogOpened: false,
      efetivarIncricaoDialogOpened: false,
      enviarLinkPagamentoDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Fornecedor',
          column: 'descricaoFornecedor',
          type: 'text'
        },
        {
          name: 'Comprador',
          column: 'descricaoComprador',
          type: 'text'
        },
        {
          name: 'Tipo Evento',
          column: 'idEventoTipo',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEventoTipo(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          name: 'Evento',
          column: 'idEvento',
          type: 'autocomplete',
          optionsFactory: (search) => findAllEvento(1,{
            descricao: search
          })
              .then(r => {
                return r.elements.map(e => ({
                  key: e.id,
                  valor: e.descricao
                }))
              })
        },
        {
          group: 'Data inscrição',
          columns: [
            {
              name: 'De',
              column: 'dtInsInicio',
              type: 'date',
            },
            {
              name: 'Até',
              column: 'dtInsFim',
              type: 'date',
            },
          ]
        },                
        {
          name: 'Status',
          column: 'status',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.STATUS_INSCRICAO
          })
        },    
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','token','isAuthenticated','nivelUsuarioLogado']),
  },
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        id: null,
        idEventoTipo: null,
        idEvento: null,
        idEventoEdicao: null,
        descEventoEdicao: "",
        inscrito: "",
        idFornecedor: null,
        idComprador: null,
        idContato: null,
        idFuncionario: null,
        dtInscricao: "",
        tipoInscricao: "",
        status: "",
        dtPagamento: "",
        maisDetalhe:'',
        ofertaDemanda: [],
        cronograma: [],
        cronogramaInscricao: [],
      };
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Inscrição. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async enviarLinkPagamento(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.enviarLinkPagamentoDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Inscrição. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Inscrição removida com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        this.$toast.error(`Não foi possível remover a Inscrição.`, {
          timeout: 6000
        })
      } finally {
        this.loading = false;
      }
    },
    async detalheInscricao(objeto) {
      try {
        this.loading = true;
        const dadosInscricao = await findInscricaoPorToken(objeto.idEventoEdicao);
        if (dadosInscricao?.current) {
          this.inscricaoEvento = {
            inscrito: 1,
            id: dadosInscricao.current.idEventoEdicao,
            urlImgCapa: dadosInscricao.current.urlImgCapa,
            descricao: dadosInscricao.current.descEventoEdicao,
            cronograma: dadosInscricao.current.cronograma,
            dtInicioInscricao: dadosInscricao.current.dtInicioInscricao,
            dtFimInscricao: dadosInscricao.current.dtFimInscricao,
            estado: dadosInscricao.current.estado,
            cidade: dadosInscricao.current.cidade,
            maisInfo: dadosInscricao.current.maisInfoEdicao,
            dtInscricao: dadosInscricao.current.dtInscricao,
            descStatus: dadosInscricao.current.descStatus,

            idInscricao: dadosInscricao.current.id,
            maisDetalheInscricao: dadosInscricao.current.maisDetalhe,
            cronogramaInscricao: dadosInscricao.current.cronograma || [],
            ofertaDemanda: dadosInscricao.current.ofertaDemanda || [],   
          };
          this.efetivarIncricaoDialogOpened = true;
          this.autenticacao = {
            dadosLogado: {
              token: this.token,
              current: this.user
            },
            encontrou: 1
          };
          this.autenticado = true;          
        } else {
          throw new ApiError('exe', 'Inscrição não localizada.');
        }
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados da Inscrição. Tente Novamente mais tarde. ${err}`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("EventoInscricao.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>